export const CreditCardsIcons = {
  VISA: 'visaCard',
  MASTER_CARD: 'masterCard',
  AMERICAN_EXPRESS: 'aeCard',
  UNKNOWN: '',
}
